<template>
  <b-row class="d-flex justify-content-center">
    <label>{{ getReplyTrans('image') }}</label>
    <b-col
      sm="12"
      md="6"
    >

      <div
        v-if="savedImage && !img.length"
        class="image-container"
        :style="{backgroundImage:'url('+form.image+')'}"
      >
        <b-button
          class="remove-button btn-icon"
          variant="danger"
          size="sm"
          @click="form.image=null"
        >
          <FeatherIcon icon="TrashIcon" />
        </b-button>
      </div>
      <my-menu-media-input
        v-else
        v-model="img"
        :single="true"
        disable-video
        @uploaded="form.image=$event.med.url"
        @select-file="setCardImage($event)"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import MyMenuMediaInput from '@/views/media/MyMenuMediaInput'
import ReplyMixin from '../../mixins/reply-mixin'

export default {
  name: 'ImageTemplate',
  components: {
    MyMenuMediaInput,
    BRow,
    BCol,
    BButton,
  },
  mixins: [ReplyMixin],
  data() {
    return {
      img: [],
    }
  },
  computed: {
    savedImage() {
      return (typeof this.form.image === 'string' || this.form.image instanceof String) && this.form.image !== ''
    },
  },
  methods: {
    getReplyTrans(string) {
      return this.$t(`reply.form.${string}`)
    },
    async submit() {
      if (!this.form.image) {
        this.$notifyError('يرجى تحميل صورة')
        throw new Error(this.$tc('errors.field-invalid', 1))
      }
    },
    setCardImage(files) {
      this.form.image = files[0]?.url ?? ''
    },
  },
}
</script>
